import React from 'react';

import { Paragraph } from '@rover/kibble/core';

type Props = { lines: number } & React.ComponentProps<typeof Paragraph>;

/**
 * This component visually truncates text to a specified number of lines using `-webkit-line-clamp`.
 * The full text remains in the DOM but is visually hidden after the defined line count.
 * This is ideal for displaying a preview of long text, while allowing it to remain accessible for
 * screen readers and crawlers.
 *
 * @param lines - Number of lines to display before truncating the rest of the text with an ellipsis
 */
const ClampedParagraph: React.FC<Props> = ({ lines, ...props }) => (
  <Paragraph
    mb="0x"
    size="100"
    textColor="primary"
    sx={{
      width: '100%',
      display: '-webkit-box',
      overflow: 'hidden',
      '-webkit-line-clamp': String(lines),
      '-webkit-box-orient': 'vertical',
    }}
    {...props}
  />
);

export default ClampedParagraph;
